export default {
  size: {
    label: 'Domyślny rozmiar papieru',
    tooltip: 'Określa rozmiar papieru, który jest zawsze wybierany domyślnie.',
  },
  language: {
    label: 'Język',
    tooltip: 'Raporty pokazują teksty swoich bloków, daty i liczby w tym języku. Nazwy i inne teksty wprowadzone przez użytkowników pozostają bez zmian.',
  },
  showTimezone: {
    label: 'Pokaż strefę czasową',
    tooltip: 'Daty i godziny w raportach podają swoją strefę czasową, np. CET. Wyłącz tę opcję, jeśli wszystkie Twoje lokalizacje są w jednej strefie czasowej',
  },
  header: {
    height: {
      tooltip: 'Określa wysokość nagłówka używaną na każdej stronie raportu.',
    },
    contentLeft: {
      tooltip: 'Określa lewy tekst nagłówka wyświetlany na każdej stronie raportu.',
    },
    contentCenter: {
      tooltip: 'Określa wyśrodkowany tekst nagłówka wyświetlany na każdej stronie raportu.',
    },
    contentRight: {
      tooltip: 'Określa prawy tekst nagłówka wyświetlany na każdej stronie raportu.',
    },
  },
  footer: {
    contentLeft: {
      tooltip: 'Określa lewy tekst stopki wyświetlany na każdej stronie raportu.',
    },
    contentCenter: {
      tooltip: 'Określa wyśrodkowany tekst stopki wyświetlany na każdej stronie raportu.',
    },
    contentRight: {
      tooltip: 'Określa prawy tekst stopki wyświetlany na każdej stronie raportu.',
    },
  },
};
